import React from 'react';

const keyframes = `
  @keyframes logoPulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.06); }
  }
  @keyframes glowPulse {
    0%, 100% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.3), 0 0 40px rgba(59, 130, 246, 0.1); }
    25% { box-shadow: 0 0 25px rgba(168, 85, 247, 0.4), 0 0 50px rgba(168, 85, 247, 0.15); }
    50% { box-shadow: 0 0 30px rgba(231, 76, 139, 0.4), 0 0 60px rgba(231, 76, 139, 0.15); }
    75% { box-shadow: 0 0 25px rgba(16, 185, 129, 0.4), 0 0 50px rgba(16, 185, 129, 0.15); }
  }
  @keyframes fadeInText {
    0%, 100% { opacity: 0.4; }
    50% { opacity: 1; }
  }
`;

const LoadingScreen = ({ message = 'Loading...' }) => (
  <>
    <style>{keyframes}</style>
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--bg-loading)',
      zIndex: 1000,
    }}>
      <div style={{
        borderRadius: '50%',
        padding: '20px',
        animation: 'glowPulse 4s ease-in-out infinite',
      }}>
        <img
          src="/assets/ayni_logo.png"
          alt="AYNI"
          className="loading-logo"
          style={{
            height: '80px',
            objectFit: 'contain',
            mixBlendMode: 'multiply',
            animation: 'logoPulse 2.5s ease-in-out infinite',
          }}
        />
      </div>
      <p style={{
        animation: 'fadeInText 2s ease-in-out infinite',
        color: 'var(--text-faint)',
        fontSize: '14px',
        fontWeight: '500',
        marginTop: '24px',
        letterSpacing: '0.5px',
      }}>
        {message}
      </p>
    </div>
  </>
);

export default LoadingScreen;
